import { AxiosResponse } from "axios";
import HttpService from "./HttpService";
import { IServiceResponse } from "../interfaces/IServiceReponse";
import { IRegisterUser } from "../interfaces/IRegisterUser";

const BASE_URL_: string = process.env.REACT_APP_API_BASE_URL!;

class UserService extends HttpService {
  constructor() {
    super(BASE_URL_, null);
  }

  registerUser(user: IRegisterUser): Promise<AxiosResponse<IServiceResponse>> {
    return this.http.post("v1/register", {
      firstname: user.firstname,
      lastname: user.surname,
      email: user.email,
      password: user.password,
      captchaToken: user.reCaptchaToken,
    });
  }
}

export default UserService;
